import { render, staticRenderFns } from "./ShippingRates.vue?vue&type=template&id=c503923c&scoped=true"
import script from "./ShippingRates.vue?vue&type=script&lang=js"
export * from "./ShippingRates.vue?vue&type=script&lang=js"
import style0 from "./ShippingRates.vue?vue&type=style&index=0&id=c503923c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c503923c",
  null
  
)

export default component.exports